import EventEmitter from "base/EventEmitter";
import ValueHelper from "base/ValueHelper";
import "ion-rangeslider/js/ion.rangeSlider";


export default class RangeInput extends EventEmitter {
    constructor($element) {
        super();
        this.$element = $element;


        this.$input = this.$element.find(".js-range-input");

        this.$min = this.$element.find(".js-range-min");
        this.$max = this.$element.find(".js-range-max");

        this.unit = this.$element.is("[data-unit]") ? this.$element.attr("data-unit") : null;
        this.unitSide = this.$element.is("[data-unit-side]") ? this.$element.attr("data-unit-side") : "left";
        this.commas = this.$element.is("[data-commas]");

        this.showDummyInputs = this.unit || this.commas;

        this.createDummyInputs();
        this.createSlider();
        this.bindEvents();

        this.updateDummyInputs();
    }

    getName() {
        return this.$element.attr("data-name");
    }


    getMinimumValue() {
        return parseInt(this.$input.attr("data-min"));
    }

    getMaximumValue() {
        return parseInt(this.$input.attr("data-max"));
    }

    createDummyInputs() {
        if (!this.showDummyInputs) return;
        this.$minDummy = this.$min.clone();
        this.$maxDummy = this.$max.clone();

        [this.$minDummy, this.$maxDummy].forEach(($dummy) => {
            $dummy.addClass("form__input--range-dummy js-no-validate form__input--range-dummy-" + ($dummy.is(".js-range-min") ? "min" : "max"));
            $dummy.removeClass("js-range-min js-range-max");
            $dummy.attr({
                "name": null,
                "data-optional": true,
                "type": "text",
                "data-type": "text",
                "tabindex": "-1",
                "id": null,
            });
        });
        this.$min.after(this.$minDummy);
        this.$max.after(this.$maxDummy);
    }

    updateDummyInputs() {
        if (!this.showDummyInputs) return;

        [[this.$min, this.$minDummy], [this.$max, this.$maxDummy]].forEach(([$input, $dummy]) => {
            let value = $input.val();

            if (this.commas && this.unitSide === "left") {
                // Handle putting the minus before the unit
                value = ValueHelper.format_money(parseFloat(value), this.unit);
            } else {
                if (this.commas) {
                    value = ValueHelper.format_thousands(parseFloat(value));
                }
                if (this.unit !== null) {
                    if (this.unitSide === "left") {
                        value = this.unit + value;
                    } else {
                        value = value + this.unit;
                    }
                }
            }

            $dummy.val(value);
        });
    }

    createSlider() {
        this.$input.ionRangeSlider({
            type: "double",
            hide_min_max: true,
            hide_from_to: true,

            min: this.getMinimumValue(),
            max: this.getMaximumValue(),

            from: this.$min.val(),
            to: this.$max.val(),

            onChange: (event) => this.onChange(event),
            onUpdate: (event) => this.onChange(event),
        });
        this.slider = this.$input.data("ionRangeSlider");
    }

    bindEvents() {
        [this.$min, this.$max].forEach(($el) => $el.on("change", (e) => {
            this.setValue({
                min: this.$min.val(),
                max: this.$max.val(),
            });
        }));
    }

    getValue() {
        let {from, to} = this.slider.result;
        return {
            min: from,
            max: to,
        };
    }

    clear() {
        this.setValue({
            min: this.getMinimumValue(),
            max: this.getMaximumValue(),
        });
    }

    setValue({min, max}) {
        this.slider.update({
            from: 'undefined' === typeof min || min === null ? this.getMinimumValue() : min,
            to: 'undefined' === typeof max || max === null ? this.getMaximumValue() : max,
        });
    }

    onChange({from, to}) {

        let hasChanged = this.$min.val() !== from || this.$max.val() !== to;

        this.$min.val(from);
        this.$max.val(to);

        if (hasChanged) {
            this.emit("change", this.getValue());
        }

        this.updateDummyInputs();
    }

    /**
     * @param $element
     * @returns {Array<RangeInput>}
     */
    static apply($element) {
        let ranges = [];
        $element.find(".js-range-filter").each((_, el) => {
            let $el = $(el);

            if ($el.data("customRange")) {
                ranges.push($el.data("customRange"));
                return;
            }

            let range = new RangeInput($el);
            ranges.push(range);

            $el.data("customRange", range);
        });

        return ranges;
    }

}
